import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-nowrap flex-row items-center w-full" }
const _hoisted_2 = ["aria-label", "placeholder", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search_button = _resolveComponent("search-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", _mergeProps({
      class: "bg-white dark:bg-gray-800 rounded-tl-2xl rounded-bl-2xl h-12 border-2 border-r-0 border-blue-700 dark:border-indigo-300 px-2 pl-3 pr-2 focus:border-blue-900 dark:focus:border-indigo-500 focus:outline-none w-full",
      "aria-label": _ctx.placeholder,
      placeholder: _ctx.placeholder,
      value: _ctx.value
    }, _ctx.$attrs, {
      onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.setFocused && _ctx.setFocused(...args))),
      onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setUnfocused && _ctx.setUnfocused(...args))),
      onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:value', $event.target.value)))
    }), null, 16, _hoisted_2),
    _createVNode(_component_search_button, {
      class: _normalizeClass([_ctx.inputFocused ? 'border-blue-900  dark:border-indigo-500' : 'border-blue-700 dark:border-indigo-300'])
    }, null, 8, ["class"])
  ]))
}